import type { IconSvgObject } from './types';

const BookDashedIcon: IconSvgObject = [
  ["path", { d: "M20 22H17M4 20C4 18.8954 4.89543 18 6 18H7M4 20C4 21.1046 4.89543 22 6 22H7M4 20V15M17 2.00435C18.2398 2.02228 18.9427 2.11424 19.4142 2.58579C19.8858 3.05733 19.9777 3.76022 19.9957 5M4.07612 5C4.17203 4.02491 4.38879 3.36857 4.87868 2.87868C5.36857 2.38879 6.02491 2.17203 7 2.07612M11 2H13M20 9V11M4 9V11M20 15V18H17M13 22H11M13 18H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 18C19.5 18 18.5 18.7628 18.5 20C18.5 21.2372 19.5 22 19.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BookDashedIcon;
